import React, { useState } from "react";

import "./App.css";

import Header from "./components/Header/Header";
import Showcase from "./components/Showcase/Showcase";
import Modal from "./components/Modal";

const App = () => {
  const [isVideoFullScreen, setIsVideoFullScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [isShowcase, setIsShowcase] = useState(false);

  // hideList = () =>{
  //   setIsShowcase(!isShowcase);
  // }

  return (
    <>
      {!isVideoFullScreen && <Header onModalOpen={() => setIsOpen(true)} />}
      <Showcase
        onVideoSelected={() => setIsVideoFullScreen(true)}
        onVideoExit={() => setIsVideoFullScreen(false)}
        isFullScreen={isVideoFullScreen}
        isModalOpen={isOpen}
      />

      <Modal isOpen={isOpen} onExit={() => setIsOpen(false)}>
        <div className="bio">
          Jozef Devillé [1979] is a multidisciplinary artist from Belgium. His
          body of work mainly focuses on film and music, but also encompasses
          photography and graphic design. Growing up in the diverse metropolis
          of Brussels, he graduated from a Master of the Audiovisual Arts at the
          RITCS. His most notable work is the award-winning documentary "The
          Sound of Belgium" [2012]. His work typically revolves around the
          themes of [sub]cultures, music, ecology, social movements, and
          traditional rituals. His documentaries have been repeatedly
          broadcasted on ARTE, VRT, RTL and Mubi.
        </div>
        <br />
      </Modal>
    </>
  );
};

export default App;
